import groupBy from 'lodash.groupby';
import get from 'lodash.get';

const shipmentProduct = (shipment, type) => shipment[type];

export const shipmentLabel = (shipment) => shipmentProduct(shipment, 'label');

export const shipmentInsurance = (shipment) => shipmentProduct(
  shipment,
  'insurance',
);

export function shipmentPackaging(shipment) {
  const { packaging: { id, name } } = shipment;

  return { id, name };
}

export function aggregatedProducts(
  shipments,
  { differential = 'productLineInsurance', includeCancelled = false },
) {
  const nonCancelledShipments = shipments.filter(
    (shipment) => shipment.state !== 'cancelled',
  );

  let baseShipments = [];

  if (includeCancelled) {
    baseShipments = shipments;
  } else {
    baseShipments = nonCancelledShipments;
  }

  const products = groupBy(baseShipments, (shipment) => {
    const productId = get(shipment, 'label.id');
    const productLineId = get(shipment, 'label.productLine.id');
    const insuranceId = get(shipment, 'insurance.id');

    let key;

    if (differential === 'label') {
      key = productId;
    }

    if (differential === 'productLine') {
      key = productLineId;
    }

    if (differential === 'productLineInsurance') {
      key = `${productLineId}:${insuranceId}`;
    }

    if (differential === 'productInsurance') {
      key = `${productId}:${insuranceId}`;
    }

    return key;
  });

  const aggregated = [];

  function totalPriceCents(group, field) {
    return group.map(
      (shipment) => shipment[field].priceCents,
    ).reduce((total, priceCents) => total + priceCents);
  }

  Object.keys(products).forEach((id) => {
    const group = products[id];

    const {
      label: {
        id: productId,
        displayName,
        productLine: { displayName: productLineDisplayName },
      },
      insurance: { coverageAmount },
    } = group[0];

    aggregated.push({
      id,
      count: group.length,
      product: displayName,
      productId,
      productLine: productLineDisplayName,
      coverageAmount,
      totals: {
        label: totalPriceCents(group, 'label'),
        insurance: totalPriceCents(group, 'insurance'),
        discounts: 0,
        fees: 0,
      },
    });
  });

  return aggregated;
}

export const pendingShipments = (state) => {
  const { orders: { shipments } } = state;

  return shipments.filter((shipment) => shipment.state === 'pending');
};

export const pendingOrCancelledShipments = (state) => {
  const { orders: { shipments } } = state;

  return shipments.filter(
    (shipment) => ['pending', 'cancelled'].includes(shipment.state),
  );
};

export const partialShipments = (state) => {
  const { orders: { shipments } } = state;

  return shipments.filter((shipment) => shipment.state === 'partial');
};

export const legShipments = (shipments, leg) => {
  if (leg === undefined) {
    return [];
  }

  return shipments.filter((shipment) => shipment.legId === leg.id);
};
